import {
  AppBar,
  Box,
  Button,
  Grid,
  TablePagination,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory, useParams } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import React, { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import KenLoader from '../../../../Components/KenLoader/index';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import KenGridEditable from '../../../../global_components/kenEditDataGrid/kenGridEditable';
import validator from 'validator';
// import '../../../../style/index.css';
import {
  getExamModuleListData,
  getSeatingPlanData,
  postSeatingPlanData,
  publishExam,
  singleExamDetails,
} from '../../../../Utils/apiServices';
import { sendMailSeatingPlan } from '../../../../Utils/sendMail';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TablePaginationActions from '../../../../global_components/KenGrid/TablePaginationActions';
import SamplePdf from '../../../../Assets/samplePdf.pdf';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useTranslation } from 'react-i18next';
import KenButton from '../../../../global_components/KenButton';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'SEATING PLAN',
  },
];
export const timeDuration = [
  {
    label: '30',
    value: '30',
  },
  {
    label: '60',
    value: '60',
  },
  {
    label: '90',
    value: '90',
  },
  {
    label: '120',
    value: '120',
  },
  {
    label: '150',
    value: '150',
  },
  {
    label: '180',
    value: 180,
  },
  {
    label: '210',
    value: '210',
  },
  {
    label: '240',
    value: '240',
  },
  {
    label: '270',
    value: '270',
  },
  {
    label: '300',
    value: '300',
  },
];

const examModeOptions = [
  {
    label: 'Online',
    value: 'Online',
  },
  {
    label: 'Offline',
    value: 'Offline',
  },
];

const formatOptions = [
  {
    label: 'Written',
    value: 'Written',
  },
  {
    label: 'Computer Based Exam Moddle',
    value: 'Computer Based Exam Moddle',
  },
  {
    label: 'Soft Copy',
    value: 'Soft Copy',
  },
];

const formatpatternOptions = [
  {
    label: 'Open Book',
    value: 'Open Book',
  },
  {
    label: 'Close Book',
    value: 'Close Book',
  },
  {
    label: 'Soft Copy',
    value: 'Soft Copy',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    background: '#272727',
    height: '28px',
    width: '78px',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: 'orange',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  normal: {
    color: 'white',

    background: '#55b0cd',

    borderRadius: '20px',
    fontSize: '10px',

    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: 'white',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishGenerate: {
    // color: '#505F79',
    color: 'white',

    background: 'green',
    // background: '#27AE60',

    // background: '#505F79',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    '&:hover': {
      background: 'green',

      color: 'white',
      // border: '1px solid white',
    },
    // color: '#FFFFFF',
    // background: '#979797',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const SeatingExamTimeTableChild = () => {
  const data = useParams();

  const [rows, setRows] = useState([]);
  const { t } = useTranslation();
  const [rowsData, setrowsData] = useState([]);
  const [startDate, setStartDate] = useState('25-02-2022');
  const [startTime, setStartTime] = useState('10: 45');
  const [previous, setPrevious] = useState({});
  const [linkState, setLinkState] = useState('Link');
  const [endDate, setEndDate] = useState('25-02-2022');
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [facultyDrop, setFacultyDrop] = useState({});
  //
  const [selectedDuration, setSelectedDuration] = useState('');
  const [loading, setLoading] = useState(false);
  const [publishData, setPublishData] = useState(null);

  //Pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const onToggleEditMode = (check, id, index) => {
    setRows((state) => {
      return rows.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  /* email send funcion */
  useEffect(() => {
    if (publishData !== null) {
      sendMailSeatingPlan(publishData?.id);
    }
  }, [publishData]);
  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };
  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };

  const open = Boolean(anchorEl);

  const onDataSave = () => {
    setLoading(true);
    const newData = [...rows];

    const payload = newData.map((row) => {
      return {
        id: row.id,
        duration: row.duration,
        dateOfExam: row.date,
        timeOfExam: row.start_time,
        examparttern: row.examparttern,
        examformate: row.examformate,
        exmMode: row.exmMode,
        examType: null,
        venue: 'Dubai',
        sendEmail: false,
      };
    });
    setLoading(true);
    postSeatingPlanData(payload)
      .then((res) => {
        setLoading(true);
        toast.success(`${res.message}`);
        getSeatingDatas();
      })
      .catch((err) => {
        setLoading(true);
        toast.error(`${err}`);
      });
    setLoading(true);
  };

  const getSeatingDatas = () => {
    setLoading(true);

    singleExamDetails(data.id)
      .then((res) => {
        const SeatingInfo = [
          {
            id: res.data[0].id,
            course: res.data[0].course ? res.data[0].course : 'NA',
            date: res.data[0].dateOfExam ? res.data[0].dateOfExam : 'NA',
            exam_type: res.data[0].examType ? res.data[0].examType : 'NA',

            exmMode: res.data[0].exmMode ? res.data[0].exmMode : 'NA',

            duration: res.data[0].duration ? res.data[0].duration : 'NA',
            examTimeZone: res.data[0].examTimeZone
              ? res.data[0].examTimeZone
              : '',
            studentFacultyRatio: res.data[0].studentFacultyRatio
              ? res.data[0].studentFacultyRatio
              : '',
            start_time: res.data[0].startTimeOfExam
              ? res.data[0].startTimeOfExam
              : 'NA',
            examformate: res.data[0].examformate
              ? res.data[0].examformate
              : 'NA',
            examparttern: res.data[0].examparttern
              ? res.data[0].examparttern
              : 'NA',
          },
        ];
        setLoading(false);
        setRows(SeatingInfo);
      })
      .catch((err) => {
        console.log('Seating Plan Data=>', err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getSeatingDatas();
  }, []);

  return (
    <Box>
      {loading && <KenLoader />}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />{' '}
      {/* test */}
      <Box className={classes.breadCrumbWrapper}>
        <BreadCrumb array={arrayBreadCrumb} history={history} />
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Exam Timetable & Seating Plan Details
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              className={classes.addButton}
              style={{ marginRight: '10px' }}
              variant="contained"
              onClick={() => history.goBack()}
            >
              Back
            </Button>
            <Button
              variant="contained"
              className={classes.addButton}
              // style={{
              //   marginRight: '15px',
              //   background: '#272727 !important',
              //   color: 'white',
              //   fontWeight: 'bold',
              //   textDecoration: 'none',
              //   textTransform: 'none',
              // }}
              onClick={onDataSave}
            >
              Save
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    fontWeight: 'bold',
                    padding: '7px',
                    background: '#FFFFFF',
                    color: '#193389',
                  }}
                  align="left"
                >
                  EXAM NAME
                </TableCell>

                <TableCell
                  style={{
                    fontWeight: 'bold',
                    padding: '7px',
                    background: '#FFFFFF',
                    color: '#193389',
                  }}
                  align="left"
                >
                  DATE
                </TableCell>
                <Tooltip placement="top" title="START TIME (IST)" arrow>
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      background: '#FFFFFF',
                      color: '#193389',
                    }}
                    align="left"
                  >
                    START TIME (IST)
                  </TableCell>
                </Tooltip>
                {/* <TableCell
                  style={{
                    fontWeight: 'bold',
                    padding: '7px',
                    background: '#FFFFFF',
                    color: '#193389',
                  }}
                  align="left"
                >
                  TIME ZONE
                </TableCell> */}
                <TableCell
                  style={{
                    fontWeight: 'bold',
                    padding: '7px',
                    background: '#FFFFFF',
                    color: '#193389',
                  }}
                  align="left"
                >
                  DURATION
                </TableCell>
                {/* <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  EXAM TYPE
                </TableCell> */}
                <Tooltip placement="top" title="EXAM TYPE" arrow>
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      background: '#FFFFFF',
                      color: '#193389',
                    }}
                    align="left"
                  >
                    EXAM TYPE
                  </TableCell>
                </Tooltip>
                <Tooltip placement="top" title="EXAM MODE" arrow>
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      background: '#FFFFFF',
                      color: '#193389',
                    }}
                    align="left"
                  >
                    EXAM MODE
                  </TableCell>
                </Tooltip>
                <Tooltip placement="top" title="FORMAT" arrow>
                  <TableCell
                    style={{
                      fontWeight: 'bold',
                      padding: '7px',
                      background: '#FFFFFF',
                      color: '#193389',
                    }}
                    align="left"
                    // rowSpan={2}
                    // colSpan={2}
                  >
                    FORMAT
                  </TableCell>
                </Tooltip>
                <TableCell
                  style={{
                    fontWeight: 'bold',
                    padding: '7px',
                    background: '#FFFFFF',
                    color: '#193389',
                  }}
                  align="left"
                  // rowSpan={2}
                  // colSpan={2}
                >
                  EXAM PARTTERN
                </TableCell>
                {/* <TableCell
                  style={{ fontWeight: 'bold', padding: '7px' }}
                  align="left"
                >
                  VENUE/LINK
                </TableCell> */}
                <TableCell
                  style={{
                    fontWeight: 'bold',
                    padding: '7px',
                    background: '#FFFFFF',
                    color: '#193389',
                  }}
                  align="left"
                >
                  EDIT
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => {
                let venueLink;
                /* if (validate(row.venue_link)) {
                  venueLink = 'kenInput';
                } else if (row.venue_link == 'Generate') {
                  venueLink = 'kenSelect';
                } */
                return (
                  <TableRow className="editableTableRowData" key={row.id}>
                    <KenGridEditable
                      {...{
                        row,
                        onChange,
                        columns: [
                          {
                            column_name: 'course',
                            is_inline_edit: false,
                            inline_edit_type: '',
                          },

                          {
                            column_name: 'date',
                            is_inline_edit: true,
                            inline_edit_type: 'kenDatePicker',
                          },
                          {
                            column_name: 'start_time',
                            is_inline_edit: true,
                            inline_edit_type: 'kenTime',
                          },
                          // {
                          //   column_name: 'examTimeZone',
                          //   is_inline_edit: false,
                          //   inline_edit_type: '',
                          // },
                          {
                            column_name: 'duration',
                            is_inline_edit: true,
                            inline_edit_type: 'kenSelect',
                            dropdown: timeDuration,
                          },

                          {
                            column_name: 'exam_type',
                            is_inline_edit: false,
                            inline_edit_type: '',
                          },
                          {
                            column_name: 'exmMode',
                            is_inline_edit: true,
                            inline_edit_type: 'kenSelect',
                            dropdown: examModeOptions,
                          },
                          // {
                          //   column_name: 'studentFacultyRatio',
                          //   is_inline_edit: false,
                          //   inline_edit_type: '',
                          // },
                          {
                            column_name: 'examformate',
                            is_inline_edit: true,
                            inline_edit_type: 'kenSelect',
                            dropdown: formatOptions,
                          },
                          {
                            column_name: 'examparttern',
                            is_inline_edit: true,
                            inline_edit_type: 'kenSelect',
                            dropdown: formatpatternOptions,
                          },
                          /* {
                            column_name: 'venue_link',
                            is_inline_edit: true,
                            inline_edit_type: venueLink,
                          }, */
                        ],
                      }}
                    />
                    <TableCell className={classes.selectTableCell}>
                      {row.isEditMode ? (
                        <>
                          <IconButton
                            aria-label="done"
                            onClick={() =>
                              onToggleEditMode('done', row.id, index)
                            }
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            aria-label="revert"
                            onClick={() => onRevert(row.id)}
                          >
                            <RevertIcon />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="edit"
                          onClick={() =>
                            onToggleEditMode('edit', row.id, index)
                          }
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </KenCard>
      </Box>
    </Box>
  );
};

export default SeatingExamTimeTableChild;
